// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".with-icon-notification-section[data-v-57784a1d]{display:grid;grid-template-columns:20px 1fr;align-items:center;column-gap:8px}", ""]);
// Exports
module.exports = exports;
